<div class="editor">

  <!-- TOP TOOLBAR -->
  <header class="top">
    <button class="button-secondary-small" (click)="loadModal('geogebra')">Geometry</button>
    <button class="button-secondary-small" (click)="loadModal('chemistry')">Chemistry</button>
  </header>

  <!-- LEFT PALETTE -->
  <aside class="left">
    <h3>Physics</h3>
    <div #paletteContainer class="palette-grid"></div>
    <!-- <ul>
      <li (click)="addResistor()">Resistor</li>
      <li (click)="addRectangle()">Rectangle</li>
      <li (click)="addLine()">Line</li>
    </ul> -->
  </aside>

  <!-- DRAW AREA -->
  <main class="center">
    <div #graphContainer tabindex="0" class="grid"></div>
  </main>

  <!-- RIGHT PROPERTIES -->
  <aside class="right">
    <h3>Properties</h3>
    <button type="button" class="button-secondary-small" (click)="loadModal('crop_image')"  style="white-space: nowrap; align-items: center; display: flex; margin-right: 3px; padding: 1px 3px">
        <mat-icon fontIcon="crop" style="color: gray; cursor: pointer; margin-right: 5px; font-size: 20px; width: fit-content; height: fit-content;"></mat-icon>
        <div>Crop Image</div>
    </button>

    <label>Angle</label>
    <input type="range" min="0" max="60">

    <label>Mass (kg)</label>
    <input type="number" value="1">
  </aside>

  <!-- BOTTOM FORMULA -->
  <footer class="bottom">
    F = m × g × sin(θ)
  </footer>

</div>
